<template>
    <div id="main-wrapper">
        <NavbarDark/>

        <section class="bg-primary position-relative">
            <div class="position-absolute start-0 top-0 w-25 h-15 bg-light rounded-end-pill opacity-25 mt-4"></div>
            <div class="position-absolute start-0 bottom-0 w-15 h-20 bg-light rounded-top-pill opacity-25 ms-4"></div>
            <div class="position-absolute end-0 top-0 w-15 h-25 bg-light rounded-bottom-pill opacity-25 me-4"></div>
            <div class="position-absolute end-0 bottom-0 w-25 h-15 bg-light rounded-start-pill opacity-25 mb-4"></div>
            <div class="ht-30"></div>
            <div class="container">
                <div class="row justify-content-center">
                    <FormThree/>
                </div>
            </div>
            <div class="ht-30"></div>
        </section>

        <section class="gray-simple">
            <div :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'" class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 col-md-12">
                        <div class="item-shorting-box">
                            <div class="item-shorting clearfix">
                                <div class="left-column pull-left">
                                    <h4 class="m-0 fs-6">
                                        {{ totalResults }} - {{ $t('Found Result') }}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center g-4">
                    <div v-if="ads.length === 0">
                        <p>{{ $t('There is no provider with these specifications yet.') }}</p>
                    </div>
                    <div v-for="(item, index) in ads" :key="index" class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <ListAds :item="item"/>
                    </div>
                </div>
                <div id="scroll-sentinel" class="text-center my-4">
                    <span v-if="loading">{{ $t('Downloading..') }}</span>
                </div>
            </div>		
        </section>

        <FooterTop :bg="'theme-bg'"/>
        <FooterDark/>
        <ScrollToTop/>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue';
import axios from 'axios';
import { useRoute } from 'vue-router';
import ListAds from '@/components/property/list-ads.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import NavbarDark from '@/components/navbar/navbar-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
import FormThree from '@/components/form/form-three.vue';
// import {useI18n} from "vue-i18n";
const route = useRoute();
const ads = ref([]);
const totalResults = ref(0);
const loading = ref(false);
const observer = ref(null);
// const { locale } = useI18n();
const fetchAds = async () => {
    loading.value = true;
    try {
        const { data } = await axios.get('/get-ads', {
            params: {
                category_id:route.query.category_id || null,
                state_id: route.query.state_id || null,
            }
        });

        ads.value = data.ads || [];
        console.log("providers",ads.value);
        
        totalResults.value = data.total || 0;
    } catch (error) {
        console.error("Error fetching ads:", error);
    } finally {
        loading.value = false;
    }
};

watch(() => route.query, fetchAds, { deep: true });

const setupObserver = () => {
    observer.value = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !loading.value) {
            fetchAds();
        }
    });

    const sentinel = document.getElementById('scroll-sentinel');
    if (sentinel) observer.value.observe(sentinel);
};

onMounted(() => {
    fetchAds();
    setupObserver();
});

onUnmounted(() => {
    if (observer.value) observer.value.disconnect();
});
</script>
